import {
    fetchBaseQuery,
    createApi
} from '@reduxjs/toolkit/query/react';
import type { PublicKey } from '@solana/web3.js';

const baseUrl = import.meta.env?.VITE_CARDS_API_URL ?? 'https://api.portal.fntworld.io/api/';

export enum CardsApiTag {
    recentTransactions = 'recentTransactions',
    cardList = 'cardList',
    card = 'card',
    getNonce = 'getNonce',
    solanaRegister = 'solanaRegister',
    countryOptions = 'countryOptions',
    paymentOptions = 'paymentOptions'
}

export interface SolanaWalletProvider {
    publicKey: PublicKey | null;
    signMessage?: (message: Uint8Array) => Promise<Uint8Array>;
}

let _cardsSession: { walletAddress: string; signatureBase64: string } | null = null;

export function setCardsSession(session: { walletAddress: string; signatureBase64: string } | null) {
    _cardsSession = session;
}

export const cardsApi = createApi({
  reducerPath: "cardsApi",
  endpoints: () => ({}),
  tagTypes: Object.values(CardsApiTag),
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      if (_cardsSession) {
        headers.set("x-solana-wallet-address", _cardsSession.walletAddress);
        headers.set("x-solana-signature", _cardsSession.signatureBase64);
      } else {
        console.warn("cardsApi: session not available yet");
      }
      return headers;
    },
  }),
});
